import { Shield, Truck, RefreshCw, Banknote } from 'lucide-react';

export const TrustBadges = () => {
  return (
    <div className="grid grid-cols-2 gap-2 pt-2">
      <div className="flex items-center gap-2 text-xs text-muted-foreground">
        <Banknote className="h-4 w-4 shrink-0 text-primary" />
        <span>Cash on Delivery</span>
      </div>
      <div className="flex items-center gap-2 text-xs text-muted-foreground">
        <Shield className="h-4 w-4 shrink-0 text-primary" />
        <span>Secure Payment</span>
      </div>
      <div className="flex items-center gap-2 text-xs text-muted-foreground">
        <RefreshCw className="h-4 w-4 shrink-0 text-primary" />
        <span>7-Day Guarantee</span>
      </div>
      <div className="flex items-center gap-2 text-xs text-muted-foreground">
        <Truck className="h-4 w-4 shrink-0 text-primary" />
        <span>Free Shipping ₹999+</span>
      </div>
    </div>
  );
};
